import { getParsedDateTime } from '@/util/helper/dateTime';
import { DATE_TIME_FORMAT_MAP } from '@/config/dateTime';
export class CareOrderBabyForTransferInstructionPage {
    #careOrderBaby;
    constructor({ careOrderBaby }) {
        this.#careOrderBaby = careOrderBaby;
    }
    get code() {
        return this.#careOrderBaby.code;
    }
    get parsedExpirationTime() {
        const expirationTime = this.#careOrderBaby.expirationTime;
        if (!expirationTime)
            return '';
        const { parsedDateTime } = getParsedDateTime({
            dateTime: expirationTime,
            format: DATE_TIME_FORMAT_MAP.YEAR_DATE_TIME_WITHOUT_DAY,
        });
        return parsedDateTime;
    }
}
